import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'
import { stream } from '../action_x.js'
import { ctrlButton } from '../ui.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    button.classList.add(utilities.modifiers.display.none)
    const pause = ctrlButton('pause', button.closest(`.${elements.meet_controls}`))
    pause.classList.remove(utilities.modifiers.display.none)

    stream('camera')
  }
})

export default button => {
  onClick.listen(button)
}
